<template>
  <v-container fluid>
    <my-modal :dialog="dialogResponse" @close="close">
      <template slot="body">
        <div v-if="importData" class="mt-3">
          <div class="text-warning" v-if="importData.duplicados">
            <h4 class="">Registros duplicados</h4>
            <v-data-table
              class="error-summary"
              :headers="iheaders"
              :items="importData.duplicados"
            >
              <template v-slot:item.errors="{ item }">
                <div v-for="(error, i) in item.errors" :key="i">
                  {{ error }}
                </div>
              </template>
            </v-data-table>
          </div>
          <div class="text-danger" v-if="importData.errores">
            <h4 class="">Registros con Errores</h4>
            <v-data-table
              class="error-summary"
              :headers="iheaders"
              :items="importData.errores"
            >
              <template v-slot:item.errors="{ item }">
                <div v-for="(error, i) in item.errors" :key="i">
                  {{ error }}
                </div>
              </template>
            </v-data-table>
          </div>
          <div class="text-success" v-if="importData.saved">
            <h4 class="">Registros Guardados</h4>
            <v-data-table
              class="error-summary"
              :headers="iheaders"
              :items="importData.saved"
            ></v-data-table>
          </div>
        </div>
      </template>
    </my-modal>

    <slot name="dialog">
      <my-modal :eager="false" :dialog="dialog" @close="close">
        <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"
          ><slot :name="slot" v-bind="scope"
        /></template>

        <template slot="header"><h3>Ingresantes a Cursadas</h3></template>
        <template slot="body">
          <v-form @submit.prevent="onSubmit">
            <slot name="other-form">
              <ingresante-form-cursado
                :ingresante-edit="editModel"
                ref="form"
                :only="only"
              >
                <template v-slot:cursados="{ ingresante }">
                  <v-select
                    multiple
                    label="Elija Materias"
                    v-model="ingresante.cursados"
                    :items="materiasPorCarrera"
                    item-text="searchTag"
                    return-object
                  ></v-select>
                </template>

                <template v-slot:matriculado="{ item }">
                  <v-switch
                    :true-value="'carrera'"
                    :false-value="0"
                    v-model="item.matriculado"
                    label="matriculado"
                  ></v-switch>
                </template>
              </ingresante-form-cursado>
            </slot>
            <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"
              ><slot :name="slot" v-bind="scope"
            /></template>
          </v-form>
        </template>
        <template v-slot:footer-btn>
          <v-btn color="blue darken-1" text @click="onSubmit"> Guardar </v-btn>
        </template>
      </my-modal>
    </slot>
    <h3>Ingresantes a Cursadas</h3>

    <v-row no-gutters align="center">
      <div class="mr-3">
        <v-btn @click="newItem" outlined color="primary">Nuevo</v-btn>
      </div>

      <import-export
        class="mr-3"
        model-class="Ingresantes"
        :path="uploadPath"
        :only="only"
        :model-fields="fields"
        :plantilla="[ingresante]"
        @close="close"
      ></import-export>

      <div class="mr-3" v-if="!matriculados">
        <v-btn @click="matricularIngresantes" outlined color="warning"
          >Matricular</v-btn
        >
      </div>
      <div class="mr-3">
        <v-btn @click="borrarTodo" outlined color="error"
          >Borrar Seleccionados</v-btn
        >
      </div>
      <div class="mr-3">
        <v-switch
          true-value="carrera"
          :false-value="0"
          label="Matriculados"
          v-model="matriculados"
        ></v-switch>
      </div>
    </v-row>

    <v-text-field
      v-model="search"
      append-icon="mdi-magnify"
      label="Search"
      single-line
      hide-details
    ></v-text-field>
    <v-data-table
      :key="tabla"
      :search="search"
      :options.sync="options"
      :server-items-length="pagination.totalCount"
      v-model="selectedItems"
      :show-select="true"
      :items="filterIngresantes"
      :headers="headers"
    >
      <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope"
        ><slot :name="slot" v-bind="scope"
      /></template>

      <template v-slot:item.actions="{ item, index }">
        <v-icon color="info" class="mr-2" @click="editItem(item, index)">
          mdi-pencil
        </v-icon>
        <v-icon color="info" @click="deleteItem(item.id)"> mdi-delete </v-icon>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import {
  // mapGetters,
  mapActions,
  mapState,
} from "vuex";
import MyModal from "@/components/templates/MyModal";
import ImportExport from "@/views/layouts/ImportExport";
import Ingresante from "@/apis/Ingresante";
import IngresanteFormCursado from "@/views/ingresante/cursado/IngresanteFormCursado";

export default {
  name: "IngresanteABMCursado",
  components: {
    IngresanteFormCursado,
    ImportExport,
    MyModal,
  },
  props: {
    uploadPath: { type: String, default: "ingresantes" },
    headers: Array,
    only: Array,
  },
  data() {
    return {
      tabla: 0,
      editModel: {},
      filters: {},
      options: { itemsPerPage: -1 },
      dialogResponse: false,
      iheaders: [
        { text: "Username", value: "username" },
        { text: "Nombre", value: "nombre" },
        { text: "Apellido", value: "apellido" },
        { text: "email", value: "email" },
        { text: "Errores", value: "errors" },
      ],
      importData: null,
      matriculados: null,
      selectedItems: [],
      search: "",
    };
  },
  methods: {
    ...mapActions("UCurricularCarreraModule", [
      "getUCurricularCarreras",
      "getAllUCurricularCarreras",
    ]),
    ...mapActions("CarreraModule", ["getCarreras"]),
    ...mapActions("IngresanteModule", [
      "getIngresantesCarrera",
      "deleteAll",
      "getMatriculados",
      "getIngresantes",
      "getFields",
      "addIngresante",
      "updateIngresante",
      "deleteIngresante",
      "editIngresante",
      "showDialog",
      "hideDialog",
      "clearErrors",
    ]),
    close() {
      this.selectedItems = [];
      this.hideDialog();
      this.dialogResponse = false;
      this.clearErrors();
      // this.getMatriculados(this.matriculados);
    },
    async onSubmit() {
      // this.addIngresante(this.ingresante);
      this.$refs.form.ingresante.id
        ? await this.updateIngresante(this.$refs.form.ingresante)
        : await this.addIngresante(this.$refs.form.ingresante);
    },
    newItem() {
      // this.fetchIngresante();
      // this.editIngresante({});
      this.editModel = {};
      this.showDialog();
    },
    editItem(item, index) {
      console.log(index);
      this.editModel = { ...item };
      // this.editIngresante(item);
      this.showDialog();
      // this.showIngresanteDialog();
    },
    deleteItem(id) {
      this.deleteIngresante(id);
    },

    async matricularIngresantes() {
      const { data } = await Ingresante.matricular({
        ingresantes: this.selectedItems,
      });
      this.importData = data;
      this.dialogResponse = true;
      this.tabla++;
    },
    async borrarTodo() {
      await this.deleteAll(this.selectedItems);
      this.reload();
    },

    reload() {
      this.filters.tipo_inscripcion = "cursado";
      this.getIngresantes({
        options: this.options,
        filters: this.filters,
        expand: ["cursado"],
      });
    },
  },
  computed: {
    ...mapState("UCurricularCarreraModule", [
      "uCurricularCarreras",
      "materiasPorCarrera",
    ]),
    ...mapState("CarreraModule", ["carreras"]),
    ...mapState("IngresanteModule", [
      "ingresantesCarrera",
      "pagination",
      "ingresantes",
      "dialog",
      "ingresante",
      "fields",
    ]),
    filterIngresantes() {
      // return this.ingresantesCarrera;
      return this.ingresantes.filter(
        (el) =>
          el.tipo_inscripcion === "cursado" &&
          el.matriculado === this.matriculados
      );
    },
    // ...mapGetters("IngresanteModule",["ingresanteList","ingresanteDialog","newIngresanteRecord","ingresante","ingresanteFields","ingresanteErrors"]),
    // ...mapGetters("IngresanteModule",["errors"]),
  },
  watch: {
    options: {
      handler() {
        this.reload();
      },
      deep: true,
    },
    filters: {
      handler() {
        localStorage.setItem("filters", JSON.stringify(this.filters));
        this.reload();
      },
      deep: true,
    },
  },
  created() {
    this.filters.rol = "alumno";
    this.filters.matriculado = this.matriculados;
    // this.getMatriculados(this.matriculados);
    this.getFields();
    this.getCarreras();
    this.getUCurricularCarreras(1);
  },
};
</script>

<style scoped></style>
